import React from 'react';

class EsqueceuSenhaSuccess extends React.Component {

    render() {
        return(
            <div id="esqueceu-senha-success-form">
                <p id="esqueceu-senha-success-txt">
                    Uma senha nova foi enviada para o seu E-mail.
                </p>
                <center>
                    <button type="button"
                        id="esqueceu-senha-success-voltar-btn"
                        onClick={ this.props.voltar }>
                        Voltar
                    </button>
                </center>
            </div>
        );
    }

}

export default EsqueceuSenhaSuccess;

